<template>
    <fieldset class="flex w-full flex-wrap">
        <fancy-select
            :vid="this.name + '.employmentStatus'"
            :name="this.name + '.employmentStatus'"
            label="What’s your current employment status?"
            v-model="employmentStatus"
            :options="defaultOptions"
            :rules="{ required: true , in: Object.keys(defaultOptions) }"
            :custom-messages="customMessages"
            @input="update"
            class="mb-2"
            tooltip="Don’t worry, your loan quote is private - nobody will be informed. We just need to ensure you have regular income."
        ></fancy-select>
        <signpost
            :signPostId="checkSignpostId"
        >
        </signpost>
        <expand-transition :duration="350">
            <digi-select
                v-if="employmentStatus == 'other'"
                :name="this.name + '.employmentStatusExtra'"
                label="Select from these additional options*"
                v-model="extraEmploymentStatus"
                :options="extraOptionsWithEmpty"
                :rules="{ required_if: { target: this.name + '.employmentStatus', values: 'other' }, in: Object.keys(this.extraOptions)}"
                :custom-messages="customMessages"
                @input="update"
                class="mb-8"
            ></digi-select>
        </expand-transition>
    </fieldset>
</template>

<script>
import FancySelect from "./../../components/form/fancyselect";
import DigiSelect from "./../../components/form/digi-select";
import { isString, extend } from "underscore";
import Signpost from './signpost';

export default {
    inject: [ '$getValidationRules', '$getValidationMessages' ],
    methods: {
        update() {
            this.$emit('input', this.employmentStatus === 'other' ? this.extraEmploymentStatus : this.employmentStatus);
            this.checkForSignposting(this.employmentStatus === 'other' ? this.extraEmploymentStatus : this.employmentStatus);
        },
        // checks whether signposting should be shown, if we want to only show for test form configs add && this.test == true
        // ensure the test parameter is set to true for the component in the form config php file
        // ensure the vue component supports the test prop, if not implement it based on the other signposting components
        // implemented by matt
        checkForSignposting(value) {
        // show signposting if employment status meets any of the below values
            if (value == 'student') {
                this.showSignposting = true;
                this.signPostId = value;
                window.amplitude.showSignposting(value + ' employment status selected');
                return;
            }
            if (value == 'unemployed') {
                this.showSignposting = true;
                this.signPostId = value;
                window.amplitude.showSignposting(value + ' employment status selected');
                return;
            }
            if ((value == 'benefits_and_fulltime' || value == 'benefits_and_parttime' || value == 'benefits')) {
                this.showSignposting = true;
                this.signPostId = value;
                window.amplitude.showSignposting(value + ' employment status selected');
                return;
            }
            this.showSignposting = false;
            this.signPostId = null;
        }
    },
    computed: {
        extraOptionsWithEmpty() {
            return extend({'' : 'Please Select...'}, this.extraOptions);
        },
        checkSignpostId() {
            if (this.signPostId) {
                return this.signPostId;
            }
        }
    },
    props: {
        name: String,
        value: String,
        defaultOptions: Object,
        extraOptions: Object,
        test: {
            default: false,
        }
    },
    data() {
        return {
            employmentStatus: null,
            extraEmploymentStatus: null,
            customMessages: {
                'required': 'Please select your employment status',
                'required_if': 'Please select your employment status',
                'in': 'Please select your employment status',
            },
            showSignposting: false,
            signPostId: null,
        };
    },
    components: {
        signpost: Signpost,
        "digi-select": DigiSelect,
        "fancy-select": FancySelect,
        'expand-transition': () => import('./../../components/expand-transition'),
    },
    created() {
        if (this.value && isString(this.value)) {
            if (Object.keys(this.defaultOptions).includes(this.value)) {
                this.employmentStatus = this.value;
            } else if (Object.keys(this.extraOptions).includes(this.value)) {
                this.extraEmploymentStatus = this.value;
                this.employmentStatus = 'other';
            }
            this.update();
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>